import moment from 'moment';

export const getCurrentYear = () => moment().get('year');
